import { STORE_HEADER } from "@app/constants/LOCALKEYS";
import useSWR from "swr";
// import { getPersistData } from '../persist'

const KEY = STORE_HEADER;

let swrData: any = KEY;
export function useHeader(initData?: any, reset?: boolean) {
  const { data, mutate } = useSWR<any>(KEY, async () => {
    if (reset === true) {
      swrData = null;
      return null;
    }
    if (initData !== undefined) {
      swrData = initData;
    }
    return swrData;
  });

  return {
    data,
    mutate: (value: any) => {
      swrData = value;
      return mutate();
    },
  };
}
